import { APP_NAME } from '@/constants/app.constant';
import { PAGE_CONTAINER_GUTTER_X } from '@/constants/theme.constant';
import classNames from '@/utils/classNames';
import Container from '@/components/shared/Container';

export type FooterPageContainerType = 'gutterless' | 'contained';

type FooterProps = {
  pageContainerType: FooterPageContainerType;
  className?: string;
};

const FooterContent = () => {
  return (
    <div className="flex w-full flex-auto items-center justify-between">
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{' '}
        <span className="font-semibold">{`${APP_NAME}`}</span> All rights reserved. Version: 1.0.0
      </span>
    </div>
  );
};

export default function Footer({ pageContainerType = 'contained', className }: FooterProps) {
  return (
    <footer
      className={classNames(
        `footer flex h-16 flex-auto items-center ${PAGE_CONTAINER_GUTTER_X}`,
        className,
      )}
    >
      {pageContainerType === 'contained' ? (
        <Container>
          <FooterContent />
        </Container>
      ) : (
        <FooterContent />
      )}
    </footer>
  );
}
